module.exports = __webpack_public_path__ + "static/media/international_group.54d6feb4.jpg";